import { ResponsiveContainer, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line } from "recharts";

const financialData = [
  { quarter: 'Q1 2022', revenue: 446353, expenses: 179830, depreciation: 19129, ebitda: 113496 },
  { quarter: 'Q2 2022', revenue: 453117, expenses: 180257, depreciation: 19615, ebitda: 114691 },
  { quarter: 'Q3 2022', revenue: 446219, expenses: 178452, depreciation: 20999, ebitda: 114347 },
  { quarter: 'Q4 2022', revenue: 446278, expenses: 182526, depreciation: 20042, ebitda: 114766 },
  { quarter: 'Q1 2023', revenue: 549797, expenses: 221574, depreciation: 24455, ebitda: 141370 },
  { quarter: 'Q2 2023', revenue: 550200, expenses: 219500, depreciation: 24700, ebitda: 143000 },
  { quarter: 'Q3 2023', revenue: 549000, expenses: 220000, depreciation: 25000, ebitda: 140000 },
  { quarter: 'Q4 2023', revenue: 552000, expenses: 223000, depreciation: 25500, ebitda: 144000 },
  { quarter: 'Q1 2024', revenue: 649500, expenses: 259000, depreciation: 28000, ebitda: 170000 },
  { quarter: 'Q2 2024', revenue: 651000, expenses: 260500, depreciation: 28500, ebitda: 172500 },
  { quarter: 'Q3 2024', revenue: 653000, expenses: 263000, depreciation: 29000, ebitda: 175000 },
  { quarter: 'Q4 2024', revenue: 655000, expenses: 265000, depreciation: 29500, ebitda: 177500 }
];

const LineRevExpEBITDA = () => {
  const formatCurrency = (value) => `$${value.toLocaleString('en-US')}`;

  return (
    <div className="bg-white rounded-lg shadow p-6 mb-8">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Financial Performance (Q1 2022 - Q4 2024)</h3>
      <div className="overflow-x-auto">
        <div className="w-[1200px]">
          <ResponsiveContainer width="100%" height={350}>
            <LineChart data={financialData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="quarter" />
              <YAxis tickFormatter={formatCurrency} tick={{ fill: '#000', fontSize: 12, width: 100 }} />
              <Tooltip formatter={(value) => formatCurrency(value)} />
              <Legend />
              <Line type="monotone" dataKey="revenue" stroke="#3B82F6" name="Revenue" />
              <Line type="monotone" dataKey="expenses" stroke="#EF4444" name="Expenses" />
              <Line type="monotone" dataKey="depreciation" stroke="#F59E0B" name="Depreciation" />
              <Line type="monotone" dataKey="ebitda" stroke="#10B981" name="EBITDA" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default LineRevExpEBITDA;
